<template>
  <h1 class="app-header">
    <slot />
  </h1>
</template>

<style scoped>
  .app-header {
    font-size: 3rem;
    margin: 20px 0;
    text-align: center;
  }
</style>
